import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AnchoredAlert } from '../AnchoredAlert';
const CANCEL_TOAST_DURATION_SECONDS = 6;
export function EmissorCancelOrderToast({ flow, testIdPrefix }) {
    if (!flow.toast) {
        return null;
    }
    return (_jsx(AnchoredAlert, { testId: `${testIdPrefix}-toast`, message: flow.toast.message, appearance: flow.toast.appearance, duration: CANCEL_TOAST_DURATION_SECONDS, onClose: flow.dismissToast }));
}
